/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';

/**
 * 
 * @export
 * @interface UpdateCompanyResponse
 */
export interface UpdateCompanyResponse {
    /**
     * 
     * @type {Company}
     * @memberof UpdateCompanyResponse
     */
    data: Company;
}

/**
 * Check if a given object implements the UpdateCompanyResponse interface.
 */
export function instanceOfUpdateCompanyResponse(value: object): value is UpdateCompanyResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateCompanyResponseFromJSON(json: any): UpdateCompanyResponse {
    return UpdateCompanyResponseFromJSONTyped(json, false);
}

export function UpdateCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompanyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CompanyFromJSON(json['data']),
    };
}

  export function UpdateCompanyResponseToJSON(json: any): UpdateCompanyResponse {
      return UpdateCompanyResponseToJSONTyped(json, false);
  }

  export function UpdateCompanyResponseToJSONTyped(value?: UpdateCompanyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CompanyToJSON(value['data']),
    };
}

